import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  collection,
  query,
  orderBy,
  addDoc,
  serverTimestamp,
  onSnapshot,
  increment,
  runTransaction,
} from "firebase/firestore";

import { db } from "../firebase";

/** Створити чат-док, якщо ще нема */
export async function ensureChat(uidPartner) {
  const chatRef = doc(db, "chats", uidPartner);
  const snap = await getDoc(chatRef);
  if (!snap.exists()) {
    await setDoc(chatRef, {
      participants: ["admin", uidPartner],
      lastMessage: null,
      lastAt: serverTimestamp(),
      unreadForAdmin: 0,
      unreadForUser: 0,
      createdAt: serverTimestamp(),
    });
  } else {
    const d = snap.data() || {};
    const patch = {};
    if (typeof d.unreadForAdmin !== "number") patch.unreadForAdmin = 0;
    if (typeof d.unreadForUser !== "number") patch.unreadForUser = 0;
    if (!("lastReadAtAdmin" in d)) patch.lastReadAtAdmin = null;
    if (!("lastReadAtUser" in d)) patch.lastReadAtUser = null;
    if (Object.keys(patch).length) await updateDoc(chatRef, patch);
  }
  return chatRef;
}

/** Надіслати повідомлення */
export async function sendMessage(uidPartner, { text, from, senderId }) {
  if (!text?.trim()) return;
  const chatRef = await ensureChat(uidPartner);
  const msgRef = collection(chatRef, "messages");
  await addDoc(msgRef, {
    text: text.trim(),
    from, // "admin" | "user"
    senderId: senderId || null,
    createdAt: serverTimestamp(),
  });

  const updates = {
    lastMessage: { text: text.trim(), from, at: serverTimestamp() },
    lastAt: serverTimestamp(),
  };
  if (from === "admin") updates.unreadForUser = increment(1);
  else updates.unreadForAdmin = increment(1);

  await updateDoc(chatRef, updates);
}

/** Поставити прочитаним (скинути лічильник для сторони who: "admin"|"user") */
// export async function markRead(uidPartner, who) {
//   const chatRef = doc(db, "chats", uidPartner);
//   await ensureChat(uidPartner);
//   await updateDoc(chatRef, {
//     unreadForAdmin: who === "admin" ? 0 : undefined,
//     unreadForUser: who === "user" ? 0 : undefined,
//   });
// }
export async function markRead(uidPartner, who) {
  const chatRef = doc(db, "chats", uidPartner);
  await ensureChat(uidPartner);
  await runTransaction(db, async (tx) => {
    const snap = await tx.get(chatRef);
    if (!snap.exists()) return;
    const data = {};
    if (who === "admin") {
      data.unreadForAdmin = 0;
      data.lastReadAtAdmin = serverTimestamp();
    } else if (who === "user") {
      data.unreadForUser = 0;
      data.lastReadAtUser = serverTimestamp();
    }
    tx.update(chatRef, data);
  });
}
/** Підписка на стрічку повідомлень (з пагінацією можна доробити пізніше) */
// export function subscribeMessages(uidPartner, cb) {
//   const chatRef = doc(db, "chats", uidPartner);
//   const msgRef = collection(chatRef, "messages");
//   return onSnapshot(
//     // orderBy без індексу не треба, використовує createdAt
//     // імпорт orderBy - якщо користуєтесь, додайте у імпорти: orderBy, query
//     // Або сортуйте на клієнті за createdAt?.seconds
//     msgRef,
//     (snap) => {
//       const list = [];
//       snap.forEach((d) => list.push({ id: d.id, ...d.data() }));
//       list.sort(
//         (a, b) => (a.createdAt?.seconds || 0) - (b.createdAt?.seconds || 0)
//       );
//       cb(list);
//     }
//   );
// }
export function subscribeMessages(uidPartner, cb) {
  const chatRef = doc(db, "chats", uidPartner);
  const msgRef = collection(chatRef, "messages");

  const q = query(msgRef, orderBy("createdAt", "asc"));
  return onSnapshot(q, (snap) => {
    const list = [];
    snap.forEach((d) => list.push({ id: d.id, ...d.data() }));
    cb(list);
  });
}
/** Підписка на чат-док (для бейджа непрочитаного тощо) */
export function subscribeChatMeta(uidPartner, cb) {
  const chatRef = doc(db, "chats", uidPartner);
  return onSnapshot(chatRef, (snap) => cb(snap.exists() ? snap.data() : null));
}
